       
export class ResetPassword {
    UserName :string;
    NewPassword :string;
    ConfirmNewPassword :string;
    ConfirmationCode:string;
   
};